import { firstBy } from "thenby";
import React from "react";
import { memo, useState, useEffect } from "react";
import { Button, Table, Modal } from "semantic-ui-react";
import { Footer } from "../../PageLayout/Footer";
import { Layout } from "../../PageLayout/Layout";
import Algolia from "../../Algolia/Algolia";
import AuditUsersDataModal from "./AuditUsersDataModal";
import AuditOfficesDataModal from "./AuditOfficesDataModal";
import ProgressLoader from "../../Common/ProgressLoader";
import SemanticDatepicker from "react-semantic-ui-datepickers";
import TableComponent from "../../TableComponent";
import useCheckMobileScreen, {
  useCheckTabScreen,
} from "../../../hooks/useCheckMobileScreen";

const { REACT_APP_ALGOLIA_AUDIT_LIST_INDEX_NAME } = process.env;

const ACTIVE_INDEX_KEY = {
  USER_DATA: "users",
  OFFICE_DATA: "offices",
};

const USER_ACTIONS = ["UPDATE_USER", "DELETE_USER", "CREATE_USER"];

const OFFICE_ACTIONS = ["UPDATE_OFFICE", "DELETE_OFFICE", "CREATE_OFFICE"];

const AuditListHOC = (props: any) => {
  const [dataList, setDataList] = useState([]);
  const [algoliaLoading, setAlgoliaLoading] = useState(true);

  const [config, setConfig] = useState({
    algoliaIndex: REACT_APP_ALGOLIA_AUDIT_LIST_INDEX_NAME, // Algolia Index Mandatory
    hitsPerPage: 10000, // No of records per page
    filters: "", // Algolia Filters
    setDataList: setDataList, // Temp set list of hits value
    dataList: dataList, // Algolia list of hits value,
    refresh: true,
    algoliaLoading: algoliaLoading,
    setAlgoliaLoading: setAlgoliaLoading,
  });

  const AuditList = () => {
    const [users, setUsers] = useState([] as any);
    const [offices, setOffices] = useState([] as any);
    const [tabIndex, setTabIndex] = useState(ACTIVE_INDEX_KEY.USER_DATA);
    const [loading, setLoading] = useState(true);
    const [activeIndexData, setActiveIndexData] = useState([] as any);
    const [auditUsersDataModal, setAuditUsersDataModal] = useState(false);
    const [auditOfficesDataModal, setAuditOfficesDataModal] = useState(false);
    const [overlay, setOverlay] = useState({ style: { display: "none" } });
    const [overlayMsg, setOverlaymsg] = useState(
      "Audit data Fetched Successfully!"
    );

    const [new_UserFirstName, setNew_UserFirstName] = useState("");
    const [new_UserLastName, setNew_UserLastName] = useState("");
    const [new_UserEmail, setNew_UserEmail] = useState("");
    const [new_UserID, setNew_UserID] = useState("");
    const [
      new_Userallowed_high_risk_processors,
      setNew_Userallowed_high_risk_processors,
    ] = useState([] as any);
    const [
      new_Userallowed_low_risk_processors,
      setNew_Userallowed_low_risk_processors,
    ] = useState([] as any);
    const [new_Userallowed_risk_levels, setNew_Userallowed_risk_levels] =
      useState([] as any);
    const [new_UserUpdated_Date, setNew_UserUpdated_Date] = useState("");
    const [new_Useroffice_id, setNew_Useroffice_id] = useState("");
    const [new_Userpartner_id, setNew_Userpartner_id] = useState("");
    const [new_Userrole_code, setNew_Userrole_code] = useState("");
    const [new_Useriris_enabled, setNew_Useriris_enabled] = useState("");
    const [newUserDeactivated, setNewUserDeactivated] = useState("");
    const [new_Userfeenavigator_enabled, setNew_Userfeenavigator_enabled] =
      useState("");
    const [newUserAllowedRms, setNewUserAllowedRms] = useState([] as any);
    const [old_UserFirstName, setOld_UserFirstName] = useState("");
    const [old_UserLastName, setOld_UserLastName] = useState("");
    const [old_UserEmail, setOld_UserEmail] = useState("");
    const [old_UserID, setOld_UserID] = useState("");
    const [
      old_Userallowed_high_risk_processors,
      setOld_Userallowed_high_risk_processors,
    ] = useState([] as any);
    const [
      old_Userallowed_low_risk_processors,
      setOld_Userallowed_low_risk_processors,
    ] = useState([] as any);
    const [old_Userallowed_risk_levels, setOld_Userallowed_risk_levels] =
      useState([] as any);
    const [old_UserUpdated_Date, setOld_UserUpdated_Date] = useState("");
    const [old_Useroffice_id, setOld_Useroffice_id] = useState("");
    const [old_Userpartner_id, setOld_Userpartner_id] = useState("");
    const [old_Userrole_code, setOld_Userrole_code] = useState("");
    const [old_Useriris_enabled, setOld_Useriris_enabled] = useState("");
    const [oldUserDeactivated, setOldUserDeactivated] = useState("");
    const [old_Userfeenavigator_enabled, setOld_Userfeenavigator_enabled] =
      useState("");
    const [oldUserAllowedRms, setOldUserAllowedRms] = useState([] as any);

    const [new_office_id, setNew_office_id] = useState("");
    const [new_office_admin_ids, setNew_office_admin_ids] = useState("");
    const [newOfficeManagerIds, setNewOfficeManagerIds] = useState([] as any);
    const [new_office_level, setNew_office_level] = useState("");
    const [new_office_name, setNew_office_name] = useState("");
    const [new_paper_apps_enabled, setNew_paper_apps_enabled] = useState("");
    const [new_parent_office_id, setNew_parent_office_id] = useState("");
    const [new_updated_date, setNew_updated_date] = useState("");
    const [
      new_allowed_high_risk_processors,
      setNew_allowed_high_risk_processors,
    ] = useState([] as any);
    const [
      new_allowed_low_risk_processors,
      setNew_allowed_low_risk_processors,
    ] = useState([] as any);
    const [new_allowed_risk_levels, setNew_allowed_risk_levels] = useState(
      [] as any
    );
    const [newAllowedRms, setNewAllowedRms] = useState([] as any);
    const [newOfficeDeactivated, setNewOfficeDeactivated] = useState("");
    const [old_office_id, setOld_office_id] = useState("");
    const [old_office_admin_ids, setOld_office_admin_ids] = useState("");
    const [oldOfficeManagerIds, setOldOfficeManagerIds] = useState([] as any);
    const [old_office_level, setOld_office_level] = useState("");
    const [old_office_name, setOld_office_name] = useState("");
    const [old_paper_apps_enabled, setOld_paper_apps_enabled] = useState("");
    const [old_parent_office_id, setOld_parent_office_id] = useState("");
    const [old_updated_date, setOld_updated_date] = useState("");
    const [
      old_allowed_high_risk_processors,
      setOld_allowed_high_risk_processors,
    ] = useState([] as any);
    const [
      old_allowed_low_risk_processors,
      setOld_allowed_low_risk_processors,
    ] = useState([] as any);
    const [old_allowed_risk_levels, setOld_allowed_risk_levels] = useState(
      [] as any
    );
    const [oldAllowedRms, setOldAllowedRms] = useState([] as any);
    const [oldOfficeDeactivated, setOldOfficeDeactivated] = useState("");

    const [defaultStartDate, setDefaultStartDate] = useState("");
    const [defaultEndDate, setDefaultEndDate] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [noSearchResultModal, setNoSearchResultModal] = useState(false);
    const [searchResultMessage, setSearchResultMessage] = useState("");
    const [noDateRangeModal, setNoDateRangeModal] = useState(false);

    const isMobile = useCheckMobileScreen();
    const isTablet = useCheckTabScreen();

    useEffect(() => {
      //TO FETCH INITIAL DATA RANGE
      getInitialDates();
    }, []);

    useEffect(() => {
      //TO FILTER INITIAL DATA WITH DATE RANGE
      if (defaultStartDate && defaultEndDate && users && users.length > 0) {
        users.forEach((user: any) => {
          const updated_time: any = new Date(
            user?.created_ts._seconds * 1000 +
              user?.created_ts._nanoseconds / 1000000
          );
          const start_date: any = new Date(startDate);
          const end_date: any = new Date(endDate);

          if (updated_time >= start_date && updated_time <= end_date) {
            setActiveIndexData((prev: any) => [...prev, user]);
          }
        });
      }
    }, [defaultStartDate, defaultEndDate, users]);

    const getInitialDates = () => {
      const current_date: any = new Date();
      const start_date: any = new Date(
        current_date.getFullYear(),
        current_date.getMonth(),
        current_date.getDate() - 7
      );
      setStartDate(start_date);
      setEndDate(current_date);
      setDefaultStartDate(start_date);
      setDefaultEndDate(current_date);
    };

    function handelUserModel(index: any) {
      setAuditUsersDataModal(true);
      const data: any = users[index];

      setNew_UserFirstName(data?.new_data?.user_name.first_name);
      setNew_UserLastName(data?.new_data?.user_name.last_name);
      setNew_UserEmail(data?.new_data?.user_email);
      setNew_UserID(data?.new_data?.user_id);
      setNew_Userallowed_high_risk_processors(
        data.new_data?.allowed_high_risk_processors?.join(", ")
      );
      setNew_Userallowed_low_risk_processors(
        data.new_data?.allowed_low_risk_processors?.join(", ")
      );
      setNew_Userallowed_risk_levels(
        data.new_data?.allowed_risk_levels?.join(", ")
      );
      setNew_UserUpdated_Date(
        createdTS(
          data?.new_data?.updated_ts._seconds,
          data?.new_data?.updated_ts._nanoseconds
        )
      );
      setNew_Useroffice_id(data?.new_data?.office_id);
      setNew_Userpartner_id(data?.new_data?.partner_id);
      setNew_Userrole_code(data?.new_data?.role_code);
      setNew_Useriris_enabled(
        data?.new_data?.iris_enabled ? "ENABLED" : "DISABLED"
      );
      setNew_Userfeenavigator_enabled(
        data?.new_data?.feenavigator_enabled ? "ENABLED" : "DISABLED"
      );
      setNewUserDeactivated(
        data.new_data?.deleted ? "DELETED" : data.new_data?.deactivate ? "INACTIVE" : "ACTIVE"
      );
      let rmNames = data.new_data?.rm_details?.map((rm: any) => {
        return `${rm?.user_name?.first_name} ${rm?.user_name?.last_name}`;
      });
      setNewUserAllowedRms(rmNames?.join(", "));
      if (data.old_data) {
        setOld_UserFirstName(data.old_data?.user_name.first_name);
        setOld_UserLastName(data.old_data?.user_name.last_name);
        setOld_UserEmail(data.old_data?.user_email);
        setOld_UserID(data.old_data?.user_id);
        setOld_Userallowed_high_risk_processors(
          data.old_data?.allowed_high_risk_processors?.join(", ")
        );
        setOld_Userallowed_low_risk_processors(
          data.old_data?.allowed_low_risk_processors?.join(", ")
        );
        setOld_Userallowed_risk_levels(
          data.old_data?.allowed_risk_levels?.join(", ")
        );
        setOld_UserUpdated_Date(
          createdTS(
            data.old_data?.updated_ts._seconds,
            data.old_data?.updated_ts._nanoseconds
          )
        );
        setOld_Useroffice_id(data.old_data?.office_id);
        setOld_Userpartner_id(data.old_data?.partner_id);
        setOld_Userrole_code(data.old_data?.role_code);
        setOld_Useriris_enabled(
          data.old_data?.iris_enabled ? "ENABLED" : "DISABLED"
        );
        setOld_Userfeenavigator_enabled(
          data.old_data?.feenavigator_enabled ? "ENABLED" : "DISABLED"
        );
        setOldUserDeactivated(
          data.old_data?.deactivate ? "INACTIVE" : "ACTIVE"
        );
        let rmNames = data.old_data?.rm_details?.map((rm: any) => {
          return `${rm?.user_name?.first_name} ${rm?.user_name?.last_name}`;
        });
        setOldUserAllowedRms(rmNames?.join(", "));
      }
    }

    function handelOfficeModel(index: any) {
      setAuditOfficesDataModal(true);
      const data: any = offices[index];
      setNew_office_id(data.new_data?.office_id);
      setNew_office_admin_ids(data.new_data?.office_admin_ids?.join(", "));
      setNewOfficeManagerIds(data.new_data?.office_manager_ids?.join(", "));
      setNew_office_level(data.new_data?.office_level);
      setNew_office_name(data.new_data?.office_name);
      setNew_paper_apps_enabled(
        data.new_data?.paper_apps_enabled ? "ENABLED" : "DISABLED"
      );
      setNew_parent_office_id(data.new_data?.parent_office_id);
      setNew_updated_date(
        createdTS(
          data?.new_data?.updated_ts._seconds,
          data?.new_data?.updated_ts._nanoseconds
        )
      );
      setNew_allowed_high_risk_processors(
        data?.new_data?.allowed_high_risk_processors?.join(", ")
      );
      setNew_allowed_low_risk_processors(
        data?.new_data.allowed_low_risk_processors?.join(", ")
      );
      setNew_allowed_risk_levels(
        data?.new_data.allowed_risk_levels?.join(", ")
      );
      let rmNames = data.new_data?.allowed_RMs?.map((rm: any) => {
        return `${rm?.user_name?.first_name} ${rm?.user_name?.last_name}`;
      });
      setNewAllowedRms(rmNames?.join(", "));
      setNewOfficeDeactivated(
        data.new_data?.deactivate ? "INACTIVE" : "ACTIVE"
      );
      if (data.old_data) {
        setOld_office_id(data.old_data?.office_id);
        setOld_office_admin_ids(data.old_data?.office_admin_ids?.join(", "));
        setOld_office_level(data.old_data?.office_level);
        setOld_office_name(data.old_data?.office_name);
        setOld_paper_apps_enabled(
          data.old_data?.paper_apps_enabled ? "ENABLED" : "DISABLED"
        );
        setOld_parent_office_id(data.old_data?.parent_office_id);
        setOld_updated_date(
          createdTS(
            data.old_data?.updated_ts._seconds,
            data.old_data?.updated_ts._nanoseconds
          )
        );
        setOld_allowed_high_risk_processors(
          data.old_data?.allowed_high_risk_processors?.join(", ")
        );
        setOld_allowed_low_risk_processors(
          data.old_data?.allowed_low_risk_processors?.join(", ")
        );
        setOld_allowed_risk_levels(
          data.old_data?.allowed_risk_levels?.join(", ")
        );
        let rmNames = data.old_data?.allowed_RMs?.map((rm: any) => {
          return `${rm?.user_name?.first_name} ${rm?.user_name?.last_name}`;
        });
        setOldAllowedRms(rmNames?.join(", "));
        setOldOfficeDeactivated(
          data.old_data?.deactivate ? "INACTIVE" : "ACTIVE"
        );
        setOldOfficeManagerIds(data.old_data?.office_manager_ids?.join(", "));
      }
    }
    const createdTS = (sec: any, nano: any) => {
      var date = new Date(sec * 1000 + nano / 1000000).toDateString();
      var d = new Date(date);
      var month = "" + (d.getMonth() + 1);
      var day = "" + d.getDate();
      var year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [month, day, year].join("-");
    };

    const sleep = (milliseconds: number) => {
      return new Promise((resolve) => setTimeout(resolve, milliseconds));
    };

    const showOverlayForThreeSeconds = async () => {
      const sstyle: any = { style: { display: "block", position: "fixed" } };
      setOverlay(sstyle);
      await sleep(2000);
      const hstyle: any = { style: { display: "none" } };
      setOverlay(hstyle);
    };

    useEffect(() => {
      if (!algoliaLoading && dataList.length > 0) {
        setLoading(false);
        dataList.sort(
          firstBy(
            function (data: any) {
              return new Date(
                data?.created_ts._seconds * 1000 +
                  data?.created_ts._nanoseconds / 1000000
              );
            },
            { direction: "desc" }
          )
        );
        dataList.forEach((x: any) => {
          if (USER_ACTIONS.includes(x.action_type_code)) {
            setUsers((prev: any) => [...prev, x]);
          }
          if (OFFICE_ACTIONS.includes(x.action_type_code)) {
            setOffices((prev: any) => [...prev, x]);
          }
        });
        showOverlayForThreeSeconds();
      }
      if (!algoliaLoading && dataList.length === 0) {
        setLoading(false);
        setOverlaymsg("");
        showOverlayForThreeSeconds();
      }
    }, [dataList, algoliaLoading]);

    const showData = (key: string) => {
      setStartDate(defaultStartDate);
      setEndDate(defaultEndDate);
      setNoSearchResultModal(false);
      setLoading(true);
      setActiveIndexData([]);
      if (key === ACTIVE_INDEX_KEY.USER_DATA) {
        setTabIndex(ACTIVE_INDEX_KEY.USER_DATA);
        users.forEach((user: any) => {
          const updated_time: any = new Date(
            user?.created_ts._seconds * 1000 +
              user?.created_ts._nanoseconds / 1000000
          );
          const start_date: any = new Date(defaultStartDate);
          const end_date: any = new Date(defaultEndDate);
          if (updated_time >= start_date && updated_time <= end_date) {
            setActiveIndexData((prev: any) => [...prev, user]);
          }
        });
      } else if (key === ACTIVE_INDEX_KEY.OFFICE_DATA) {
        setTabIndex(ACTIVE_INDEX_KEY.OFFICE_DATA);
        offices.forEach((office: any) => {
          const updated_time: any = new Date(
            office?.created_ts._seconds * 1000 +
              office?.created_ts._nanoseconds / 1000000
          );
          const start_date: any = new Date(defaultStartDate);
          const end_date: any = new Date(defaultEndDate);

          if (updated_time >= start_date && updated_time <= end_date) {
            setActiveIndexData((prev: any) => [...prev, office]);
          }
        });
      } else {
        setTabIndex("");
        setActiveIndexData([]);
      }
      setLoading(false);
    };

    const handleViewClick = (index: number, key: string) => {
      if (key === ACTIVE_INDEX_KEY.USER_DATA) {
        handelUserModel(index);
      } else if (key === ACTIVE_INDEX_KEY.OFFICE_DATA) {
        handelOfficeModel(index);
      }
    };

    const handleCancel = (refresh_data: boolean) => {
      if (refresh_data) showData(tabIndex);
      setAuditUsersDataModal(false);
      setAuditOfficesDataModal(false);
      setNew_UserFirstName("");
      setNew_UserLastName("");
      setNew_UserEmail("");
      setNew_UserID("");
      setNew_Userallowed_high_risk_processors([]);
      setNew_Userallowed_low_risk_processors([]);
      setNew_Userallowed_risk_levels([]);
      setNew_UserUpdated_Date("");
      setNew_Useroffice_id("");
      setNew_Userpartner_id("");
      setNew_Userrole_code("");
      setNew_Useriris_enabled("");
      setNew_Userfeenavigator_enabled("");
      setOld_UserFirstName("");
      setOld_UserLastName("");
      setOld_UserEmail("");
      setOld_UserID("");
      setOld_Userallowed_high_risk_processors([]);
      setOld_Userallowed_low_risk_processors([]);
      setOld_Userallowed_risk_levels([]);
      setOld_UserUpdated_Date("");
      setOld_Useroffice_id("");
      setOld_Userpartner_id("");
      setOld_Userrole_code("");
      setOld_Useriris_enabled("");
      setOld_Userfeenavigator_enabled("");
      setNewOfficeDeactivated("");
      setOldUserAllowedRms("");
      setOldUserDeactivated("");
      setNewUserAllowedRms("");
      setNewUserDeactivated("");

      setNew_office_id("");
      setNew_office_admin_ids("");
      setNewOfficeManagerIds("");
      setNew_office_level("");
      setNew_office_name("");
      setNew_paper_apps_enabled("");
      setNew_parent_office_id("");
      setNew_updated_date("");
      setNew_allowed_high_risk_processors("");
      setNew_allowed_low_risk_processors("");
      setNew_allowed_risk_levels("");
      setNewAllowedRms("");
      setOld_office_id("");
      setOld_office_admin_ids("");
      setOld_office_level("");
      setOld_office_name("");
      setOld_paper_apps_enabled("");
      setOld_parent_office_id("");
      setOld_updated_date("");
      setOld_allowed_high_risk_processors("");
      setOld_allowed_low_risk_processors("");
      setOld_allowed_risk_levels("");
      setOldAllowedRms("");
      setOldOfficeDeactivated("");
      setOldOfficeManagerIds("");

      setNoSearchResultModal(false);
      setNoDateRangeModal(false);
      window.scrollTo(0,0);
    };

    const handleClear = () => {
      showData(tabIndex);
    };

    const handleSearch = () => {
      setLoading(true);
      setActiveIndexData([]);
      let updated_data: any[] = [];
      if (tabIndex === ACTIVE_INDEX_KEY.USER_DATA) {
        setTabIndex(ACTIVE_INDEX_KEY.USER_DATA);
        users.forEach((user: any) => {
          const updated_time: any = new Date(
            user?.created_ts._seconds * 1000 +
              user?.created_ts._nanoseconds / 1000000
          );
          const start_date: any = new Date(startDate);
          const end_date: any = new Date(endDate);
          const end_date_final: any = new Date(
            end_date.getFullYear(),
            end_date.getMonth(),
            end_date.getDate() + 1
          );
          if (updated_time >= start_date && updated_time <= end_date_final) {
            updated_data.push(user);
          }
        });
      } else if (tabIndex === ACTIVE_INDEX_KEY.OFFICE_DATA) {
        setTabIndex(ACTIVE_INDEX_KEY.OFFICE_DATA);
        offices.forEach((office: any) => {
          const updated_time: any = new Date(
            office?.created_ts._seconds * 1000 +
              office?.created_ts._nanoseconds / 1000000
          );
          const start_date: any = new Date(startDate);
          const end_date: any = new Date(endDate);
          const end_date_final: any = new Date(
            end_date.getFullYear(),
            end_date.getMonth(),
            end_date.getDate() + 1
          );
          if (updated_time >= start_date && updated_time <= end_date_final) {
            updated_data.push(office);
          }
        });
      } else {
        setTabIndex("");
        setActiveIndexData([]);
      }
      if (!startDate || !endDate) setNoDateRangeModal(true);
      if (!updated_data || updated_data.length <= 0)
        setNoSearchResultModal(true);
      setActiveIndexData(updated_data);
      setLoading(false);
    };
    const FilterContainer = () => (
      <div className="flex-spacebetween mob-audit-filter">
        <div className="date-filter">
          <label>Start Date :</label>
          <SemanticDatepicker
            placeholder={!isMobile ? "MM-DD-YYYY" : "Start Date"}
            format="MM-DD-YYYY"
            datePickerOnly={true}
            name="FromDate"
            autoComplete="new-password"
            value={startDate ? new Date(startDate) : null}
            onChange={(event, { value }: any) => {
              setStartDate(value <= new Date() ? value : null);
            }}
            filterDate={(date) => {
              const now = new Date();
              return date <= now;
            }}
          />
        </div>
        <div className="date-filter">
          <label>End Date :</label>
          <SemanticDatepicker
            placeholder={!isMobile ? "MM-DD-YYYY" : "End Date"}
            format="MM-DD-YYYY"
            datePickerOnly={true}
            name="FromDate"
            autoComplete="new-password"
            value={endDate ? new Date(endDate) : null}
            onChange={(event, { value }: any) => {
              setEndDate(value <= new Date() ? value : null);
            }}
            filterDate={(date) => {
              const now = new Date();
              const start_date: any = new Date(startDate);
              return date <= now && date >= start_date;
            }}
          />
        </div>
        {!!startDate && !!endDate ? (
          <div className="button-container">
            <button className="not-active-btn" onClick={() => handleClear()}>
              Clear
            </button>
            <button className="active-btn" onClick={() => handleSearch()}>
              Search
            </button>
          </div>
        ) : (
          <>
          <div className="button-container gray-disabled-button">
            <button className="not-active-btn">
              Clear
            </button>
            <button className="active-btn">
              Search
            </button>
          </div>
          </>
        )}
      </div>
    );
    const NoDateRangeModal = () => (
      <Modal
        size="mini"
        closeIcon
        centered
        open={noDateRangeModal}
        onClose={() => handleCancel(true)}
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        <Modal.Header>
          <div className="email-activity-header">
            <h3> Warning</h3>
          </div>
        </Modal.Header>
        <Modal.Content>
          <div className="word-wrap">
            <p>Please select a valid date range</p>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button color="red" onClick={() => handleCancel(true)}>
            OK
          </Button>
        </Modal.Actions>
      </Modal>
    );
    const NoSeachResultsModal = () => (
      <Modal
        size="mini"
        closeIcon
        centered
        open={noSearchResultModal}
        onClose={() => handleCancel(true)}
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        <Modal.Header>
          <div className="email-activity-header">
            <h3> Search Result</h3>
          </div>
        </Modal.Header>
        <Modal.Content>
          <div className="word-wrap">
            <p>
              No data found From{" "}
              <b>{`${new Date(startDate).getMonth() + 1}-${new Date(
                startDate
              ).getDate()}-${new Date(startDate).getFullYear()}`}</b>{" "}
              to{" "}
              <b>{`${new Date(endDate).getMonth() + 1}-${new Date(
                endDate
              ).getDate()}-${new Date(endDate).getFullYear()}`}</b>
            </p>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button color="blue" onClick={() => handleCancel(true)}>
            OK
          </Button>
        </Modal.Actions>
      </Modal>
    );

    const TabHeader = () => (
      <div className="audit-btn mobile-tabs-slider">
        <button
          className={
            tabIndex === ACTIVE_INDEX_KEY.USER_DATA
              ? "active-btn"
              : "not-active-btn"
          }
          onClick={() => showData(ACTIVE_INDEX_KEY.USER_DATA)}
        >
          Audit Users
        </button>
        <button
          className={
            tabIndex === ACTIVE_INDEX_KEY.OFFICE_DATA
              ? "active-btn"
              : "not-active-btn"
          }
          onClick={() => showData(ACTIVE_INDEX_KEY.OFFICE_DATA)}
        >
          Audit Offices
        </button>
      </div>
    );

    const getTableKeys = (forUser: boolean) => {
      let rowkeys: any = [];
      let headerKeys: any = [];
      if (isMobile) {
        rowkeys = [
          { label: "Updated date", key: "updateDate" },
          { label: "Updated by User ID", key: "updateId" },
          { label: "Updated by User Name", key: "updateName" },
        ];
        headerKeys = [
          { label: forUser ? "User ID" : "Office ID", key: "id" },
          { label: forUser ? "User Name" : "Office Name", key: "name" },
          { label: "Action Name", key: "action" },
        ];
      } else if (isTablet) {
        if (window.innerHeight > window.innerWidth) {
          rowkeys = [
            { label: "Updated by User ID", key: "updateId" },
            { label: "Updated by User Name", key: "updateName" }
          ];
          headerKeys = [
            { label: forUser ? "User ID" : "Office ID", key: "id" },
            { label: forUser ? "User Name" : "Office Name", key: "name" },
            { label: "Action Name", key: "action" },
            { label: "Updated date", key: "updateDate" }
          ];
        } else {
          rowkeys = [];
          headerKeys = [
            { label: forUser ? "User ID" : "Office ID", key: "id" },
            { label: forUser ? "User Name" : "Office Name", key: "name" },
            { label: "Action Name", key: "action" },
            { label: "Updated date", key: "updateDate" },
            { label: "Updated by User ID", key: "updateId" },
            { label: "Updated by User Name", key: "updateName" }
          ];
        }
      }

      return {
        headerKeys,
        rowkeys
      }
      
    }

    const TableAuditLogsMobile = () => {
      const forUser = tabIndex === ACTIVE_INDEX_KEY.USER_DATA;

      const tableKeys = getTableKeys(forUser);
      
      const records = activeIndexData.map((i: any, index: number) => ({
        ...i,
        action: i.action_type_code.split("_")[0],
        id: forUser ? i.new_data.user_id : i.new_data.office_id,
        updateDate: createdTS(i.created_ts._seconds, i.created_ts._nanoseconds),
        updateId: i.created_by_user_details
          ? i.created_by_user_details.user_id
          : " ",
        updateName: `${
          i.created_by_user_details
            ? i.created_by_user_details.user_name?.first_name
            : " "
        } ${
          i.created_by_user_details
            ? i.created_by_user_details.user_name.last_name
            : " "
        }`,
        name: forUser
          ? `${i.new_data?.user_name?.first_name} ${i.new_data?.user_name?.last_name}`
          : i.new_data.office_name,
        onClickActions: () => handleViewClick(index, tabIndex),
      }));

      return (
        <TableComponent
          headerList={tableKeys.headerKeys}
          rowKeys={tableKeys.rowkeys}
          tableData={records}
          heading={isMobile ? "Audit List" : ""}
          uniqueId={"objectID"}
          overrideActions={true}
          noAppMessage={
            "No logs available for the selected range"
          }
          actionButton={<Button
            icon="eye"
            style={{ backgroundColor: 'transparent' }}
          />}
          loading={loading || algoliaLoading}
        />
      );
    };

    const TableAuditLogsDesktop = () => (
      <Table
        style={{ padding: 10 }}
        textAlign="center"
        celled
        striped
        structured
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
              {tabIndex === ACTIVE_INDEX_KEY.USER_DATA
                ? "User ID"
                : "Office ID"}
            </Table.HeaderCell>
            <Table.HeaderCell>
              {tabIndex === ACTIVE_INDEX_KEY.USER_DATA
                ? "User Name"
                : "Office Name"}
            </Table.HeaderCell>
            <Table.HeaderCell>Action Name</Table.HeaderCell>
            <Table.HeaderCell>Updated Date</Table.HeaderCell>
            <Table.HeaderCell>Updated By UserID</Table.HeaderCell>
            <Table.HeaderCell>Updated By UserName</Table.HeaderCell>
            <Table.HeaderCell>Actions</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {activeIndexData.map((i: any, index: any) => {
            return (
              <Table.Row key={index}>
                <Table.Cell>
                  {tabIndex === ACTIVE_INDEX_KEY.USER_DATA
                    ? i.new_data.user_id
                    : i.new_data.office_id}
                </Table.Cell>
                <Table.Cell>
                  {tabIndex === ACTIVE_INDEX_KEY.USER_DATA
                    ? `${i.new_data?.user_name?.first_name} ${i.new_data?.user_name?.last_name}`
                    : i.new_data.office_name}
                </Table.Cell>
                <Table.Cell>{i.action_type_code.split("_")[0]}</Table.Cell>
                <Table.Cell>
                  {createdTS(i.created_ts._seconds, i.created_ts._nanoseconds)}
                </Table.Cell>
                <Table.Cell>
                  {i.created_by_user_details
                    ? i.created_by_user_details.user_id
                    : " "}
                </Table.Cell>
                <Table.Cell>
                  {i.created_by_user_details
                    ? i.created_by_user_details?.user_name?.first_name
                    : " "}{" "}
                  {i.created_by_user_details
                    ? i.created_by_user_details?.user_name?.last_name
                    : " "}
                </Table.Cell>
                <Table.Cell>
                  <Button
                    icon="eye"
                    onClick={() => handleViewClick(index, tabIndex)}
                  />
                </Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    );

    return (
      <>
        <Layout page="audit">
           {!auditUsersDataModal && !auditOfficesDataModal || (!isMobile) ? (
            <div className="userslist-container">
              <div
                className={
                  window.innerWidth > 1640
                    ? "body-content"
                    : "listapp-body-content"
                }
              >
                {!isMobile ? (
                  <div className="heading flex-spacebetween mob-audit-heading-filter">
                    <span className="heading-text-left">Audit List</span>
                    <FilterContainer />
                    <TabHeader />
                  </div>
                ) : (
                  <>
                    <FilterContainer />
                    <TabHeader />
                  </>
                )}
                {isMobile || isTablet ? (
                  <TableAuditLogsMobile />
                ) : (
                  <TableAuditLogsDesktop />
                )}
                {tabIndex === ACTIVE_INDEX_KEY.USER_DATA ? (users?.length === 0) && !loading && (!isMobile && !isTablet) && (
                      <div className="body-content">
                        <div className="heading">
                          <span className="heading-center">
                          No logs available for the selected range
                          </span>
                        </div> 
        </div>)
        : <></>
                    }
                       {tabIndex === ACTIVE_INDEX_KEY.OFFICE_DATA ? (offices?.length === 0) && !loading && (!isMobile && !isTablet) &&(
                      <div className="body-content">
                        <div className="heading">
                          <span className="heading-center">
                          No logs available for the selected range
                          </span>
                        </div> 
        </div>)
        : <></>
                    }
              </div>
              <ProgressLoader loading={loading} size="large" />
            </div>
          ) : (
            <></>
          )}
          <div className="overlay" style={overlay.style}>
            <div className="overlay-image">
              <span className="overlay-text">{overlayMsg}</span>
            </div>
          </div>
          {auditUsersDataModal && (
            <AuditUsersDataModal
              auditUsersDataModal={auditUsersDataModal}
              New_FirstName={new_UserFirstName}
              New_LastName={new_UserLastName}
              New_Email={new_UserEmail}
              New_ID={new_UserID}
              New_allowed_high_risk_processors={
                new_Userallowed_high_risk_processors
              }
              New_allowed_low_risk_processors={
                new_Userallowed_low_risk_processors
              }
              New_allowed_risk_levels={new_Userallowed_risk_levels}
              New_Updated_Date={new_UserUpdated_Date}
              New_office_id={new_Useroffice_id}
              New_partner_id={new_Userpartner_id}
              New_role_code={new_Userrole_code}
              New_iris_enabled={new_Useriris_enabled}
              New_feenavigator_enabled={new_Userfeenavigator_enabled}
              Old_FirstName={old_UserFirstName}
              Old_LastName={old_UserLastName}
              Old_Email={old_UserEmail}
              Old_ID={old_UserID}
              Old_allowed_high_risk_processors={
                old_Userallowed_high_risk_processors
              }
              Old_allowed_low_risk_processors={
                old_Userallowed_low_risk_processors
              }
              Old_allowed_risk_levels={old_Userallowed_risk_levels}
              Old_Updated_Date={old_UserUpdated_Date}
              Old_office_id={old_Useroffice_id}
              Old_partner_id={old_Userpartner_id}
              Old_role_code={old_Userrole_code}
              Old_iris_enabled={old_Useriris_enabled}
              Old_feenavigator_enabled={old_Userfeenavigator_enabled}
              setAuditUsersDataModal={setAuditUsersDataModal}
              handleCancel={handleCancel}
              newUserDeactivated={newUserDeactivated}
              oldUserDeactivated={oldUserDeactivated}
              newUserAllowedRms={newUserAllowedRms}
              oldUserAllowedRms={oldUserAllowedRms}
            />
          )}
          {auditOfficesDataModal && (
            <AuditOfficesDataModal
              auditOfficesDataModal={auditOfficesDataModal}
              New_office_id={new_office_id}
              New_office_admin_ids={new_office_admin_ids}
              New_office_level={new_office_level}
              New_office_name={new_office_name}
              New_paper_apps_enabled={new_paper_apps_enabled}
              New_parent_office_id={new_parent_office_id}
              New_updated_date={new_updated_date}
              New_allowed_high_risk_processors={
                new_allowed_high_risk_processors
              }
              New_allowed_low_risk_processors={new_allowed_low_risk_processors}
              New_allowed_risk_levels={new_allowed_risk_levels}
              newAllowedRms={newAllowedRms}
              Old_office_id={old_office_id}
              Old_office_admin_ids={old_office_admin_ids}
              Old_office_level={old_office_level}
              Old_office_name={old_office_name}
              Old_paper_apps_enabled={old_paper_apps_enabled}
              Old_parent_office_id={old_parent_office_id}
              Old_updated_date={old_updated_date}
              Old_allowed_high_risk_processors={
                old_allowed_high_risk_processors
              }
              Old_allowed_low_risk_processors={old_allowed_low_risk_processors}
              Old_allowed_risk_levels={old_allowed_risk_levels}
              setAuditOfficesDataModal={setAuditOfficesDataModal}
              oldAllowedRms={oldAllowedRms}
              handleCancel={handleCancel}
              newOfficeDeactivated={newOfficeDeactivated}
              oldOfficeDeactivated={oldOfficeDeactivated}
              newOfficeManagerIds={newOfficeManagerIds}
              oldOfficeManagerIds={oldOfficeManagerIds}
            />
          )}
          {noSearchResultModal && <NoSeachResultsModal />}
          {noDateRangeModal && <NoDateRangeModal />}
          <Footer page="audit" />
        </Layout>
      </>
    );
  };

  return <> {Algolia(AuditList, { config })} </>;
};

export default memo(AuditListHOC);
